import React, { Fragment, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Dispatch } from "redux";
import { getSettings } from "../../store/actions/application.actions";

/**
 * Component used to load the settings from the API when the app starts.
 **/
const Settings: React.FC = () => {
    const dispatch: Dispatch<any> = useDispatch();

    useEffect(() => {
        dispatch(getSettings());
    }, [dispatch]);

    return (
        <Fragment>
        </Fragment>
    );
}

export default Settings;